import { getUsageSnapshot } from '@/api/usage';
import { assertNoteMediaUploadFits, NoteMediaQuotaError } from '@trove-shared';

export { NoteMediaQuotaError };

export async function assertNoteMediaUploadAllowed(byteLength: number): Promise<void> {
  const snap = await getUsageSnapshot(false, { view: 'quota' });
  const bucket = snap.resources.noteMediaStorage;
  assertNoteMediaUploadFits(bucket?.used ?? 0, bucket?.max ?? 0, byteLength);
}
